import { Bracket } from "@portal-frontend-ssr/blast-api";
import { DateTime } from "luxon";

/**
 * Sorts the brackets by start date and expands the brackets that should be expanded by default.
 */
export const getSortedBrackets = (brackets: Bracket[]) => {
  let activeBracketStartDate: DateTime | null = null;

  const maxStartDate = brackets.reduce((max, bracket) => {
    const bracketStartDate = bracket.startDate ? DateTime.fromISO(bracket.startDate) : null;
    if (!bracketStartDate?.isValid) return max;
    return bracketStartDate > max ? bracketStartDate : max;
  }, DateTime.fromMillis(0));

  const sorted = brackets
    .toSorted((a, b) => a.index - b.index)
    .map((bracket) => {
      let isExpanded = false;
      const bracketStartDate = bracket.startDate ? DateTime.fromISO(bracket.startDate) : null;
      const bracketEndDate = bracket.endDate ? DateTime.fromISO(bracket.endDate) : null;

      if (!bracketStartDate?.isValid || !bracketEndDate?.isValid) {
        return {
          bracket,
          isExpanded,
        };
      }

      // If now is after the max start date, expand the brackets with the max start date
      if (DateTime.now() > maxStartDate) {
        if (bracketStartDate.equals(maxStartDate)) {
          isExpanded = true;
        }

        return {
          bracket,
          isExpanded,
        };
      }

      // Any bracket that has the same start date as the active bracket start date should be expanded
      if (activeBracketStartDate && bracketStartDate.equals(activeBracketStartDate)) {
        isExpanded = true;
      }

      const startOfToday = DateTime.now().startOf("day");

      // If we are before the start date, expand if no other bracket is active
      if (startOfToday <= bracketStartDate && !activeBracketStartDate) {
        isExpanded = true;
        activeBracketStartDate = bracketStartDate;
      } else if (startOfToday >= bracketStartDate && startOfToday <= bracketEndDate) {
        isExpanded = true;
        activeBracketStartDate = bracketStartDate;
      }

      return {
        bracket,
        isExpanded,
      };
    });

  return sorted;
};
